import $ from 'jquery';
import 'slick-carousel';
//video popup
const cards = document.querySelectorAll('.video-card');
const popup = document.querySelector('.popup');

const popupContent = document.getElementById('popup-content');

cards.forEach(card => {
    card.addEventListener('click', () => {
        const content = card.getAttribute('data-content');
        popupContent.innerHTML = content;
        popup.style.display = 'flex';
        body.style.overflow = 'hidden';

    });
});
$(".vid-close-btn").click(function() {
    $(".popup").hide();
    $("body").css('overflow','');
});

//video popup end

// carousel

var $carousel = $('.slider');
var slideCount = $('.slider .slick-slide').length;
var numSlide = $carousel.attr("data-slidesToShow");
var settings = {
   dots: true,
   arrows: true,
   //slide: '.slide-item',
   slidesToShow: numSlide,
   arrows: true,
   appendArrows: $(".vid_arrows"),
   prevArrow: '<div class="vid_arrow vid_arrow_dir_left"><svg  width="44" height="43" viewBox="0 0 45 45" fill="none"><path d="M17.6171 21.6452L24.5241 14.7382C24.9957 14.2666 25.7609 14.2666 26.2336 14.7382C26.7052 15.2098 26.7052 15.976 26.2336 16.4477L20.1814 22.4998L26.2336 28.552C26.7052 29.0236 26.7052 29.7899 26.2336 30.2615C25.7609 30.7331 24.9957 30.7331 24.5241 30.2615L17.6171 23.3545C17.1444 22.8829 17.1444 22.1166 17.6171 21.645V21.6452Z" fill="#202020"/></svg></div>',
   nextArrow: '<div class="vid_arrow vid_arrow_dir_right"><svg  width="44" height="43" viewBox="0 0 44 43" fill="none"><path d="M26.7719 22.3354L20.0219 29.0854C19.561 29.5463 18.8132 29.5463 18.3513 29.0854C17.8904 28.6245 17.8904 27.8757 18.3513 27.4148L24.2659 21.5002L18.3513 15.5856C17.8904 15.1247 17.8904 14.3758 18.3513 13.9149C18.8132 13.4541 19.561 13.4541 20.0219 13.9149L26.7719 20.6649C27.2339 21.1258 27.2339 21.8747 26.7719 22.3356V22.3354Z" fill="#202020"/></svg></div>',
   dots: true,
   appendDots: $('.slider-dots-box'),
   dotsClass: 'slider-dots',

   responsive: [{
         breakpoint: 1024, // Desktop and larger screens
         settings: slideCount < numSlide ? "unslick" : {}
      },
      {
         breakpoint: 769,
         settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '80px',


         }
      }


   ]
};

function setSlideVisibility() {
   //Find the visible slides i.e. where aria-hidden="false"
   var visibleSlides = $carousel.find('.slider .slick-slide[aria-hidden="false"]');
   //Make sure all of the visible slides have an opacity of 1
   $(visibleSlides).each(function () {
      $(this).css('opacity', 1);
   });
}

$carousel.slick(settings);
$carousel.slick('slickGoTo', 0);
setSlideVisibility();

$carousel.on('afterChange', function () {
   setSlideVisibility();
});


// WEBPACK FOOTER //
// ./components/video-signpost_carousel/scripts/video-signpost-carousel.js